<template>
  <v-sheet class="pa-3 mr-4">
    <v-row>
      <v-col cols="6">
        <v-skeleton-loader class="mx-auto" type="list-item" />
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  name: 'SkeletonLoaderTitleUpdate',
}
</script>
